import { FormControlLabel, makeStyles, TextField, Switch } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({});

const SwitchInput = (props) => {
  const classes = useStyles();
  return <FormControlLabel control={<Switch {...props} />} label={props.label} />;
};

export default SwitchInput;
